export default "__VITE_ASSET__CXWX6V6I__"